module.exports = __webpack_public_path__ + "img/non_inventory.e1e73577.png";